import React from 'react';
import { Typography } from '@mui/material';
import { TextIcon } from '@europrocurement/flexy-components';
import { dateToFrenchFormat } from '@europrocurement/l2d-utils';
import InfoCardDossier from '../../InfoCardDossier/InfoCardDossier';
import { UpdateDateCardProps } from './types';

const UpdateDateCard: React.FunctionComponent<UpdateDateCardProps> = function ({
    dateUpdate,
    infoCardSx,
    textStyle,
}) {
    return (
        <InfoCardDossier
            label="Dernière mise à jour"
            sx={infoCardSx}
        >
            <TextIcon
                icon={{ props: { icon: ['fasl', 'calendar'] } }}
                gap="6px"
            >
                <Typography
                    sx={textStyle}
                    component="span"
                >
                    {dateToFrenchFormat(new Date(dateUpdate))}
                </Typography>
            </TextIcon>
        </InfoCardDossier>
    );
};

export default UpdateDateCard;
